import * as React from 'react';
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';

import './AccountProfile.page.scss';
import { GlobalPrivateState, dynamicTitles, dynamicTitlesKey, formatMessage } from 'src/api';

import MESSAGES from './AccountProfile.messages';

import { AccountSecurity } from 'src/app/Partials/Account/AccountSecurity';
import { AccountProfile } from 'src/app/Partials/Account/AccountProfile';

export interface AccountProfilePageProps {
  dispatch: any;
}

export class AccountProfilePageComponent extends React.Component<AccountProfilePageProps> {
  componentDidMount() {
    this.props.dispatch(dynamicTitles.add({
      key: dynamicTitlesKey.dashboard,
      value: formatMessage(MESSAGES.accountProfileHeadline),
    }));
  }

  public render() {
    return (
      <div className="page-account">
        <div className="container pt-5">
          <div className="row">
            <div className="account-edit col-12 p-0">
              <div className="row m-0 p-0">
                <AccountProfile />
                <AccountSecurity />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


}

export const AccountProfilePage = connect((state: GlobalPrivateState) => ({
}))(AccountProfilePageComponent);

export default AccountProfilePage;